<template>
    <div class="panel">
        <div class="head">
            <span class="title">添加单位成员</span>
        </div>

        <div v-if="pageAuth">
            <add-group-member ref="addGroupMember"></add-group-member>
            <div class="save-btn">
                <Button type="primary" :loading="btnLoading" class="do-save-btn" @click="saveUser">提交</Button>
            </div>
        </div>

    </div>
</template>

<script>
    import AddGroupMember from "./business/AddGroupMember";
    import baseAuthEnum from "@/staticData/baseAuthEnum";
    import utils from "@/utils";
    import $api from "@/service/index";

    export default {
        components:{
            AddGroupMember,
        },
        data(){
            return {
                //页面权限
                pageAuth : false,
                //提交按钮loading
                btnLoading : false,
            }
        },
        created(){
            this.getPageAuth();
        },
        methods : {
            //获取权限
            getPageAuth(){
                this.pageAuth = utils.judgeAuth([baseAuthEnum.ADD_USER],1);
            },
            //提交按钮
            saveUser(){
                let _self = this;
                if(this.pageAuth === false){
                    return false;
                }
                let res = this.$refs.addGroupMember.getData();
                if(!res || res.length <= 0){
                    return false;
                }
                //重名和重手机号监测
                let matchName = [];
                let matchPhone = [];
                for(let i =0 ; i < res.length ; i++){
                    if(matchName.indexOf(res[i].username.trim()) > -1){
                        utils.notice("请勿填写重复的姓名");
                        return false;
                    }else{
                        matchName.push(res[i].username.trim());
                    }

                    if(matchPhone.indexOf(res[i].tkphone.trim()) > -1){
                        utils.notice("请勿填写重复的手机号");
                        return false;
                    }else{
                        matchPhone.push(res[i].tkphone.trim());
                    }

                }

                this.btnLoading = true;
                $api.addGroupMembers(res).then(data=>{
                    _self.btnLoading = false;
                    if(data.code === "200"){
                        // utils.notice("提交成功","success");
                        utils.message({title: "提交成功"}, 'success');
                        //重置表单
                        _self.$refs.addGroupMember.resetForm();
                    }else{
                        // utils.notice(data.msg,"error");
                        utils.message({title: data.msg}, 'error');
                    }
                });
            }
        }
    }
</script>

<style scoped>
@import "index.less";
</style>


// WEBPACK FOOTER //
// src/pages/company/addMember/Index.vue